export type BroRecordType =
  | 'arrayString'
  | 'boolean'
  | 'double'
  | 'float'
  | 'int'
  | 'long'
  | 'mapLong'
  | 'string'
  | 'unformattedInt';

interface BroRecordTypes {
  [name: string]: BroRecordType;
}

export const broDnsAnswer: BroRecordTypes = {
  resourceRecord: 'string',
  ttl: 'int',
};

export const broFtpCmdarg: BroRecordTypes = {
  arg: 'string',
  cmd: 'string',
  seq: 'int',
  ts: 'long',
};

export const broFtpDataChannel: BroRecordTypes = {
  originH_asnNumber: 'unformattedInt',
  originH_asnOrg: 'string',
  originH_city: 'string',
  originH_countryCode: 'string',
  originH_countryName: 'string',
  originH_ipv4IntValue: 'long',
  originH_isInternal: 'boolean',
  originH_isp: 'string',
  originH_latitude: 'float',
  originH_location: 'string',
  originH_longitude: 'float',
  originH_region: 'string',
  originH_version: 'int',
  originH: 'string',
  passive: 'boolean',
  respH_asnNumber: 'unformattedInt',
  respH_asnOrg: 'string',
  respH_city: 'string',
  respH_countryCode: 'string',
  respH_countryName: 'string',
  respH_ipv4IntValue: 'long',
  respH_isInternal: 'boolean',
  respH_isp: 'string',
  respH_latitude: 'float',
  respH_location: 'string',
  respH_longitude: 'float',
  respH_region: 'string',
  respH_version: 'int',
  respH: 'string',
  respP: 'int',
};

export const broSmbCommand: BroRecordTypes = {
  argument: 'string',
  name: 'string',
  rtt: 'double',
  status: 'string',
  subCommand: 'string',
  treePath: 'string',
  treeService: 'string',
  username: 'string',
  version: 'string',
};

export const broSmbFile: BroRecordTypes = {
  action: 'string',
  timestamps: 'mapLong',
};

export const broSmbMapping: BroRecordTypes = {
  fileSystem: 'string',
  path: 'string',
  service: 'string',
  shareType: 'string',
};

export const broSmbTree: BroRecordTypes = {
  fileSystem: 'string',
  path: 'string',
  service: 'string',
  shareType: 'string',
  timestamp: 'long',
};

export const broSmtpHeaders: BroRecordTypes = {
  date: 'string',
  firstReceived: 'string',
  from: 'string',
  helo: 'string',
  inReplyTo: 'string',
  mailfrom: 'string',
  msgId: 'string',
  rcptto: 'arrayString',
  replyTo: 'string',
  secondReceived: 'string',
  subject: 'string',
  to: 'arrayString',
  xOriginatingIp_asnNumber: 'unformattedInt',
  xOriginatingIp_asnOrg: 'string',
  xOriginatingIp_city: 'string',
  xOriginatingIp_countryCode: 'string',
  xOriginatingIp_countryName: 'string',
  xOriginatingIp_ipv4IntValue: 'long',
  xOriginatingIp_isInternal: 'boolean',
  xOriginatingIp_isp: 'string',
  xOriginatingIp_latitude: 'float',
  xOriginatingIp_location: 'string',
  xOriginatingIp_longitude: 'float',
  xOriginatingIp_region: 'string',
  xOriginatingIp_version: 'int',
  xOriginatingIp: 'string',
};
